module.exports = __webpack_public_path__ + "static/media/graham-waving.4b6ded22.gif";